import React from 'react';
import { Head, Link } from '@inertiajs/react';
import { Card, Button } from '~/marketing/ui';
import { quoted as Q } from '~/marketing/marketingData';
import { routes } from '~/marketing/routes';
import { withMarketingLayout } from '~/marketing/MarketingLayout';

/* Contract: GET /grader/sent → { email = '' }. The address travels in the
   flash, so a refresh renders without it — the sentence reads either way.
   Never move it into the query string. The report is not rendered here and
   nothing implies it is on its way to this page: it goes to the inbox. */
export default function Sent({ email = '' }) {
  return (
    <>
      <Head title="Check received" />
      <main className="sp-page" style={{ paddingBlock: 'clamp(40px,5vw,72px)', maxWidth: 720 }}>
        <Card variant="data">
          <div style={{ display: 'grid', gap: 'var(--space-5)' }}>
            <span className="sp-label" style={{ color: 'var(--teal)' }}>Check received</span>
            <h1 style={{ fontSize: 'var(--fs-h2)' }}>We'll email you the report.</h1>
            <p style={{ color: 'var(--text-body)', maxWidth: '52ch', margin: 0 }}>
              It goes to {email ? <span className="sp-mono" style={{ color: 'var(--text-strong)' }}>{email}</span> : 'the address you entered'} once every AI assistant has answered. You can close this page.
            </p>
            {/* The sending domain is new, and Gmail calls the folder Spam where
                Outlook and Apple Mail call it Junk. */}
            <p style={{ color: 'var(--text-body)', maxWidth: '52ch', margin: 0 }}>
              If it isn't in your inbox, check your spam or junk folder.
            </p>
            {/* **This page paraphrased a Class 2 string and understated it**,
                corrected 2026-10-09 by the tone pass. It read "The link in that
                email is the only way to open the report. Nothing is published."
                `report_private` was sanctioned on 2026-10-05 precisely because
                the claim "was already rendering in three places as page copy —
                the form, the confirmation, and the result email", and only the
                form was moved onto it; this is the confirmation.
                The paraphrase is also the weaker-than-true half. A token in a
                URL is an unguessable address rather than a password, so the
                sanctioned string says the link is the whole of its security
                **and** that forwarding the mail hands it on. "Nothing is
                published" promises a protection the design does not have, on
                the screen where somebody has just handed over an address. */}
            <p className="sp-caption" style={{ margin: 0 }}>{Q.report_private}</p>
            <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
              <Button variant="secondary" href={routes.methodology}>How we measure</Button>
              <Link href={routes.grader} className="sp-caption" style={{ alignSelf: 'center' }}>Check a different business</Link>
            </div>
          </div>
        </Card>
      </main>
    </>
  );
}

Sent.layout = withMarketingLayout;
